module.exports = {"540233100":"下司马镇","540233101":"帕里镇","540233200":"下亚东乡","540233201":"上亚东乡","540233202":"康布乡","540233203":"堆纳乡","540233204":"吉汝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540233.json
// module id = 2700
// module chunks = 0